const MEDICAL_EXPENSE = 'Medical'
const HOME_EXPENSE = 'Home repair'
const CAR_EXPENSE = 'Car repair'

const MEDICAL_EVENT = 'Medical issue'
const HOME_EVENT = 'Home/property issue'
const CAR_EVENT = 'Car issue'

const EXPENSE_TO_EVENT = {
  [MEDICAL_EXPENSE]: MEDICAL_EVENT,
  [HOME_EXPENSE]: HOME_EVENT,
  [CAR_EXPENSE]: CAR_EVENT,
}

const EVENT_TO_EXPENSE = {
  [MEDICAL_EVENT]: MEDICAL_EXPENSE,
  [HOME_EVENT]: HOME_EXPENSE,
  [CAR_EVENT]: CAR_EXPENSE,
}

export default {
  EXPENSE_TO_EVENT,
  EVENT_TO_EXPENSE,
}
